import { observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

@observer
class SettingsView extends React.Component<InjectedIntlProps, {}> {

  public render() {
    const { intl: { formatMessage } } = this.props;
    return <div>{ formatMessage({ id: 'settings' }) }</div>;
  }

}

export default injectIntl(SettingsView);


// WEBPACK FOOTER //
// ./src/settings/SettingsView.tsx